module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section_title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 1 YOGA WISDOM: BEGIN IN STABILITY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/06chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 2 YOGA WISDOM: MAKE A RESOLUTION TODAY AND AFFIRM IT AGAIN AND AGAIN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 3 YOGA POSE: BE POISED FOR CHANGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 4 YOGA WISDOM: WE ARE ELEMENTS OF NATURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 5 YOGA WISDOM: TELLING YOUR STORY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 6 MANTRA: THE DIVINE IN ME BOWS TO THE DIVINE IN YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 7 YOGA WISDOM: SPEND TIME WITH OTHERS TO EXPAND YOUR WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 8 YOGA WISDOM: MAKE TODAY AN ACT OF CREATIVE SELF-EXPRESSION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 9 YOGA WISDOM: FIND YOUR CENTER WHEN THINGS FEEL CHAOTIC")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 10 MEDITATION: WHAT IS MEDITATION?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 11 YOGA WISDOM: BALANCE IS A PROCESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 12 YOGA POSE: YOU ARE POISED FOR FLIGHT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 13 YOGA WISDOM: TREAT YOURSELF WITH COMPASSION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 14 YOGA WISDOM: HONOR YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 15 A TALE FROM YOGA MYTHOLOGY: GANESHA AND SUBRAHMANYA’S RACE AROUND THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 16 YOGA WISDOM: LOOK FOR THE DIVINE IN EVERYONE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 17 YOGA WISDOM: FACE FORWARD AND OPEN TO YOUR FUTURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 18 YOGA WISDOM: YOGA IS: FULLNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 19 YOGA WISDOM: THERE IS NO SUCH THING AS INACTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 20 YOGA WISDOM: CHOOSE HAPPINESS AND MAKE IT A PRACTICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 21 YOGA WISDOM: CULTIVATE ABUNDANCE IN YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 22 MEDITATION: MEDITATE ON A SINGLE POINT TO FIND FOCUS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 23 BREATHING EXERCISE: STAY PRESENT IN THE MOMENT WHEN THINGS GET TOUGH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF KRISHNA AND KALIYA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 25 BREATHING EXERCISE: OUR BREATH IS OUR CONVERSATION WITH THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 26 YOGA WISDOM: COMMIT TO FIVE MINUTES OF YOGA A DAY TO CREATE A HOME PRACTICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 27 YOGA WISDOM: WHAT INSPIRES YOU?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/32chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 28 YOGA POSE: CREATE BALANCE WITH YOUR BODY AND MIND")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/33chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 29 YOGA WISDOM: WRITE TO RELEASE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/34chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 30 YOGA WISDOM: WHEN JUDGMENT SERVES US AND WHEN IT DOESN’T")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/35chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAN 31 MUDRA: HONOR YOUR HEART’S INTENTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/36chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 1 YOGA WISDOM: LET GO OF THE PAST TO MOVE FORWARD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/37chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 2 YOGA WISDOM: KARMA MEANS ACTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/38chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 3 YOGA POSE: TAP INTO YOUR RESOLVE AND YOUR POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/39chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 4 YOGA WISDOM: DEVELOP AN INTIMATE RELATIONSHIP WITH YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/40chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 5 YOGA WISDOM: DARE TO BE DIFFERENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 6 MANTRA: ACKNOWLEDGING EVERYTHING THAT EXISTS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/42chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 7 YOGA WISDOM: DO YOU WANT TO BE RIGHT OR DO YOU WANT TO BE HAPPY?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/43chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 8 YOGA WISDOM: TRANSITION AND CHANGE ARE THE NATURE OF LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/44chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 9 YOGA WISDOM: BE AT HOME WHEREVER YOU ARE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/45chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 10 MEDITATION: MEDITATE ON A WORD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/46chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 11 YOGA WISDOM: LIVING WITH OUR LIMITATIONS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/47chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 12 YOGA POSE: OPEN YOUR HEART WITH URDHVA DANURASANA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/48chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 13 YOGA WISDOM: FORGIVE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/49chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 14 YOGA WISDOM: HONOR NATURE TO HONOR YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/50chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 15 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF AGNI AND SWAHA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/51chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 16 YOGA WISDOM: YOU ARE BODY. YOU ARE SPIRIT.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/52chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 17 YOGA WISDOM: FINDING EASE WITH OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/53chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 18 YOGA WISDOM: YOGA IS: HOLISTIC")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/54chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 19 YOGA POSE: CONNECT WITHIN TO FIND COURAGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/55chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 20 YOGA WISDOM: OUR DIFFICULT EMOTIONS HAVE A PURPOSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/56chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 21 YOGA WISDOM: GENEROSITY CREATES POSITIVE ENERGY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/57chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 22 MEDITATION: MALA MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/58chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 23 YOGA WISDOM: YOUR FACE IS A CANVAS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/59chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF SHIVA’S BLUE THROAT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/60chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 25 BREATHING EXERCISE: OBSERVE YOUR BREATH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/61chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 26 YOGA WISDOM: SAY YES TO LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/62chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 27 MUDRA: WHEN YOU BELIEVE IN YOURSELF, YOU BECOME FEARLESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/63chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEB 28 YOGA WISDOM: YOUR ENVIRONMENT TELLS A STORY ABOUT WHO YOU ARE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/64chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 1 YOGA WISDOM: ACKNOWLEDGE YOUR WEAKNESSES TO EMBRACE YOUR STRENGTHS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/65chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 2 YOGA WISDOM: TAKE A LEAP TOWARD YOUR DREAM")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/66chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 3 YOGA POSE: BE PROUD OF WHO YOU ARE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/67chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 4 YOGA WISDOM: YOUR HANDS, YOUR TOUCH, YOUR ENGAGEMENT WITH THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/68chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 5 YOGA WISDOM: EACH YOGA POSE INVITES YOU TO EXPERIENCE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/69chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 6 MANTRA: I BOW DOWN TO THE GREAT CREATIVE POWER OF THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/70chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 7 YOGA WISDOM: APPRECIATING CONNECTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/71chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 8 YOGA WISDOM: ALIGN YOUR ACTIONS WITH YOUR WORDS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/72chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 9 YOGA WISDOM: HOLD THE SPACE FOR OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/73chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 10 MEDITATION: MEDITATE BY SERVING OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/74chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 11 YOGA WISDOM: TAKE YOURSELF ON A DATE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/75chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/76chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 12 YOGA POSE: ROOT DOWN AND BALANCE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/76chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/77chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 13 YOGA WISDOM: BE EMPATHETIC, BUT ACT WITH COMPASSION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/77chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/78chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 14 YOGA WISDOM: HONOR YOUR TEACHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/78chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 15 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF BABY KRISHNA AND THE DUST DEMON")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/79chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/80chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 16 YOGA WISDOM: YOU ARE A WORLD UNTO YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/80chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/81chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 17 YOGA WISDOM: KNOW WHEN TO ENGAGE AND WHEN TO LET GO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/81chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/82chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 18 YOGA WISDOM: YOGA IS: ALIGNMENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/82chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/83chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 19 YOGA POSE: FIND BALANCE TO FIND PEACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/83chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/84chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 20 YOGA WISDOM: LOOK FOR LIFE’S SWEETNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/84chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/85chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 21 YOGA WISDOM: TRUST THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/85chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/86chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 22 MEDITATION: MAKE YOUR MORNING INTO A MEDITATIVE RITUAL")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/86chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/87chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 23 YOGA WISDOM: CREATE THE SACRED")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/87chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/88chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF GANESHA AND GAJAMUKHA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/88chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/89chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 25 BREATHING EXERCISE: CONNECT YOUR MIND TO YOUR HEART THROUGH YOUR BREATH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/89chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/90chapter85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 26 YOGA WISDOM: RELEASE CONTROL TO COLLABORATE WITH THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/90chapter85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/91chapter86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 27 YOGA WISDOM: YOGA IS: MOVING MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/91chapter86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/92chapter87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 28 YOGA WISDOM: ALL IS OKAY IN THIS MOMENT. AND THIS MOMENT. AND THIS MOMENT.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/92chapter87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/93chapter88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 29 MUDRA: HOLD YOURSELF IN MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/93chapter88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/94chapter89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 30 YOGA WISDOM: BALANCE IS A JUGGLING OF ASYMMETRIES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/94chapter89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/95chapter90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAR 31 YOGA WISDOM: CREATE THE STORY OF YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/95chapter90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/96chapter91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 1 YOGA WISDOM: YOGA IS: MIND + BODY + HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/96chapter91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/97chapter92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 2 YOGA WISDOM: CULTIVATE INNER STRENGTH TO ACCESS YOUR INNER COURAGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/97chapter92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/98chapter93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 3 YOGA POSE: STAND IN YOUR GREATNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/98chapter93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/99chapter94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 4 YOGA WISDOM: DECLUTTER YOUR ENVIRONMENT TO DECLUTTER YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/99chapter94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/100chapter95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 5 YOGA WISDOM: YOU MIRROR THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/100chapter95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/101chapter96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 6 MANTRA: FIND YOUR INNER STRENGTH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/101chapter96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/102chapter97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 7 YOGA WISDOM: CHANCE ENCOUNTERS CAN TRANSFORM OUR LIVES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/102chapter97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/103chapter98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 8 YOGA WISDOM: CULTIVATING YOUR INNER VOICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/103chapter98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/104chapter99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 9 MEDITATION: MEDITATE WITH YOUR EYES OPEN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/104chapter99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/105chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 10 YOGA WISDOM: EMBRACING OUR IMPERFECTIONS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/105chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/106chapter101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 11 YOGA POSE: STABILIZE TO SUPPORT YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/106chapter101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107chapter102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 12 YOGA WISDOM: YOUR REACTION TO OTHERS TEACHES YOU ABOUT YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/107chapter102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/108chapter103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 13 YOGA WISDOM: HONOR YOURSELF TODAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/108chapter103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/109chapter104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 14 MUDRA: GROUND YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/109chapter104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/110chapter105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 15 YOGA WISDOM: YOGA IS: A PRAYER OF GRATITUDE SPOKEN THROUGH YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/110chapter105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/111chapter106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 16 YOGA WISDOM: WE DON’T NEED TO MAKE SOMEONE WRONG TO MAKE OURSELVES RIGHT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/111chapter106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/112chapter107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 17 YOGA WISDOM: YOGA IS: MOVEMENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/112chapter107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/113chapter108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 18 YOGA POSE: REVERSE YOUR PATTERNS TO FIND EASE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/113chapter108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/114chapter109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 19 YOGA WISDOM: THERE IS NO WRONG EMOTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/114chapter109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/115chapter110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 20 YOGA WISDOM: MAKE A DAILY GRATITUDE LIST")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/115chapter110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/116chapter111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 21 MEDITATION: TURN DOING WHAT YOU LOVE INTO MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/116chapter111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/117chapter112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 22 YOGA WISDOM: YOUR SPINE IS A BALANCE OF SUPPLENESS AND POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/117chapter112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/118chapter113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 23 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF SHIVA NATARAJA AND THE SAGES IN THE FOREST")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/118chapter113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/119chapter114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 24 BREATHING EXERCISE: BREATHE INTO YOUR FEET TO GROUND AND NOURISH YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/119chapter114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/120chapter115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 25 YOGA WISDOM: THE HEAT OF YOUR YOGA PRACTICE WILL TRANSFORM YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/120chapter115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/121chapter116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 26 YOGA WISDOM: THERE IS A TIME TO SPEAK AND A TIME TO LISTEN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/121chapter116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/122chapter117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 27 YOGA WISDOM: ACCESSING PEACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/122chapter117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/123chapter118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 28 YOGA WISDOM: THE DIFFERENCE BETWEEN HABIT AND RITUAL")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/123chapter118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/124chapter119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 29 MUDRA: OPEN YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/124chapter119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/125chapter120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APR 30 YOGA WISDOM: SELF-ACCEPTANCE SETS US FREE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/125chapter120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/126chapter121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 1 YOGA WISDOM: SHED AN OLD HABIT TO CREATE A NEW ONE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/126chapter121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/127chapter122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 2 YOGA WISDOM: CULTIVATE YOUR INNER POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/127chapter122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/128chapter123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 3 YOGA POSE: ENGAGE WITH LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/128chapter123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/129chapter124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 4 YOGA WISDOM: DEALING WITH CHANGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/129chapter124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/130chapter125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 5 YOGA WISDOM: FINDING WONDER IN YOUR BODY’S SURFACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/130chapter125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/131chapter126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 6 MANTRA: I INVITE BEAUTY, ABUNDANCE, AND GOOD FORTUNE INTO MY LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/131chapter126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/132chapter127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 7 YOGA WISDOM: DON’T BE AFRAID TO BE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/132chapter127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/133chapter128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 8 YOGA WISDOM: DAYDREAM TO TAP INTO YOUR CREATIVE LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/133chapter128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/134chapter129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 9 MEDITATION: MEDITATION IS WATCHING YOUR THOUGHTS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/134chapter129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/135chapter130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 10 YOGA WISDOM: SPEAK TO YOURSELF WITH LOVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/135chapter130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/136chapter131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 11 YOGA POSE: YOU ARE THE LOTUS BLOSSOM")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/136chapter131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/137chapter132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 12 YOGA WISDOM: OFFER COMPASSION TO CREATE A BETTER WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/137chapter132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/138chapter133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 13 YOGA WISDOM: THE WISDOM OF MULTIPLE PERSPECTIVES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/138chapter133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/139chapter134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 14 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF KRISHNA IN THE MARKETPLACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/139chapter134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/140chapter135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 15 YOGA WISDOM: THE EXPERIENCE OF FULLNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/140chapter135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/141chapter136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 16 YOGA WISDOM: LEARNING TO LISTEN TO OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/141chapter136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/142chapter137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 17 YOGA WISDOM: YOGA IS: WISDOM")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/142chapter137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/143chapter138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 18 YOGA POSE: FIND GRACE WITHIN POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/143chapter138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/144chapter139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 19 YOGA WISDOM: WHEN IT’S RIGHT TO BE FIERCE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/144chapter139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/145chapter140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 20 YOGA WISDOM: THE IMPORTANCE OF GIVING BACK")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/145chapter140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/146chapter141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 21 YOGA WISDOM: ACCEPTING WHAT WE DON’T UNDERSTAND")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/146chapter141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/147chapter142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 22 MEDITATION: MEDITATE ON TASTE AND SMELL")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/147chapter142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/148chapter143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 23 YOGA WISDOM: YOGA WILL WAKE YOU UP")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/148chapter143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/149chapter144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF KALI’S WILD DANCE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/149chapter144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/150chapter145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 25 BREATHING EXERCISE: YOUR BREATH IS A RIVER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/150chapter145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/151chapter146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 26 YOGA WISDOM: YOGA IS: ASANA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/151chapter146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/152chapter147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 27 YOGA WISDOM: CHOOSE YOUR WORDS WITH PRECISION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/152chapter147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/153chapter148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 28 YOGA WISDOM: CONNECT WITH NATURE TO CONNECT WITH YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/153chapter148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/154chapter149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 29 MUDRA: MAKE AN OFFERING TO THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/154chapter149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/155chapter150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 30 YOGA WISDOM: SURRENDER TO MOVE FORWARD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/155chapter150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/156chapter151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY 31 YOGA WISDOM: WHAT WE WANT AND WHAT WE NEED")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/156chapter151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/157chapter152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 1 YOGA WISDOM: OPEN AND RECEIVE THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/157chapter152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/158chapter153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 2 YOGA WISDOM: SHAPE YOUR DAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/158chapter153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/159chapter154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 3 YOGA POSE: STAY GROUNDED WHILE GROWING")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/159chapter154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/160chapter155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 4 YOGA WISDOM: ARRIVE AT YOUR MAT IN A WAY THAT HONORS YOUR YOGA PRACTICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/160chapter155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/161chapter156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 5 YOGA WISDOM: WE ARE ONE AND WE ARE MANY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/161chapter156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/162chapter157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 6 MANTRA: I BOW DOWN TO THE UNIVERSAL POWER OF TRANSFORMATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/162chapter157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/163chapter158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 7 YOGA WISDOM: THE IMPORTANCE OF BEING BY YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/163chapter158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/164chapter159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 8 YOGA WISDOM: FOCUS YOUR VISION TO FOCUS YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/164chapter159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/165chapter160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 9 BREATHING EXERCISE: FINDING TRANQUILITY WHEREVER WE ARE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/165chapter160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/166chapter161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 10 MEDITATION: GROUND YOURSELF THROUGH MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/166chapter161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/167chapter162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 11 YOGA WISDOM: BE LIKE WATER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/167chapter162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/168chapter163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 12 YOGA POSE: HOLDING OURSELVES WITH LOVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/168chapter163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/169chapter164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 13 YOGA WISDOM: GENERATE KINDNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/169chapter164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/170chapter165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 14 YOGA WISDOM: LET THE WORLD SING TO YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/170chapter165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/171chapter166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 15 YOGA WISDOM: HONOR EACH DAY OF YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/171chapter166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/172chapter167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 16 A TALE FROM YOGA MYTHOLOGY: A MYTH OF BRAHMA AND GANESHA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/172chapter167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/173chapter168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 17 YOGA WISDOM: YOU ARE MORE THAN YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/173chapter168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/174chapter169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 18 YOGA WISDOM: CULTIVATE ATTENTIVENESS TO EXPERIENCE WONDER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/174chapter169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/175chapter170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 19 YOGA WISDOM: YOGA IS: CONNECTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/175chapter170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/176chapter171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 20 YOGA POSE: THE DANCE OF LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/176chapter171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/177chapter172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 21 YOGA WISDOM: YOGA IS: A COMMITMENT TO YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/177chapter172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/178chapter173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 22 YOGA WISDOM: PRACTICE GENEROSITY TO CREATE ABUNDANCE IN THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/178chapter173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/179chapter174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 23 MEDITATION: MEDITATE ON THE SOUNDS AROUND YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/179chapter174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/180chapter175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 24 YOGA WISDOM: YOU HAVE PRESENCE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/180chapter175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/181chapter176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 25 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF MATSYENDRA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/181chapter176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/182chapter177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 26 YOGA WISDOM: REVERENCE OFFERS US THE EXPERIENCE OF GRATITUDE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/182chapter177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/183chapter178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 27 MUDRA: YOU ARE CONNECTED TO THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/183chapter178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/184chapter179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 28 BREATHING EXERCISE: FOCUS ON THE BREATH TO EXPERIENCE THE MIRACULOUS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/184chapter179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/185chapter180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 29 YOGA WISDOM: BE FIERY WHEN NEEDED")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/185chapter180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/186chapter181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUN 30 YOGA WISDOM: FALL IN LOVE WITH YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/186chapter181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/187chapter182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 1 YOGA WISDOM: CULTIVATE SLOWNESS TO CONNECT TO THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/187chapter182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/188chapter183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 2 YOGA WISDOM: HAVE COURAGE TO ACT ON YOUR CONVICTIONS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/188chapter183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/189chapter184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 3 YOGA POSE: BE STURDY YET RESILIENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/189chapter184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/190chapter185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 4 YOGA WISDOM: FIND SPACIOUSNESS IN YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/190chapter185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/191chapter186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 5 MANTRA: MAY THERE BE PEACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/191chapter186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/192chapter187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 6 YOGA WISDOM: WE SHARE A COMMON HUMANITY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/192chapter187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/193chapter188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 7 YOGA WISDOM: APPROACH THE WORLD LIKE A CHILD TO EXPERIENCE WONDER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/193chapter188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/194chapter189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 8 YOGA WISDOM: CONSISTENCY AND REPETITION CAN CREATE POSITIVE HABITS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/194chapter189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/195chapter190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 9 MEDITATION: MEDITATE AT DAWN AND AT DUSK")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/195chapter190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/196chapter191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 10 YOGA WISDOM: LOVING YOURSELF IS LOVING THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/196chapter191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/197chapter192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 11 YOGA POSE: TWIST GENTLY TO CREATE POWERFUL CHANGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/197chapter192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/198chapter193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 12 YOGA WISDOM: COMPASSION FOR OTHERS IS COMPASSION FOR YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/198chapter193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/199chapter194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 13 YOGA WISDOM: BEGIN THE REST OF YOUR LIFE AT THIS MOMENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/199chapter194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/200chapter195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 14 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF PARVATI AND GANESHA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/200chapter195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/201chapter196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 15 YOGA WISDOM: YOGA ENABLES US TO ACCESS SPIRIT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/201chapter196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/202chapter197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 16 YOGA WISDOM: LEARNING TO LISTEN TO OURSELVES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/202chapter197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/203chapter198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 17 YOGA WISDOM: YOGA IS: AN EXPRESSION OF BEAUTY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/203chapter198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/204chapter199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 18 YOGA POSE: GROUND YOURSELF TO GO WITHIN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/204chapter199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/205chapter200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 19 YOGA WISDOM: FIND THE HUMOR IN LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/205chapter200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/206chapter201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 20 YOGA WISDOM: EXPRESS YOUR GRATITUDE AND TRANSFORM YOUR EXPERIENCE OF THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/206chapter201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/207chapter202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 21 MEDITATION: WALKING MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/207chapter202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/208chapter203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 22 YOGA WISDOM: YOU ARE AN EXQUISITELY MADE STRUCTURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/208chapter203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/209chapter204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 23 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF DURGA, THE BUFFALO-DEMON SLAYER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/209chapter204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/210chapter205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 24 BREATHING EXERCISE: LET YOUR BREATH BE YOUR TEACHER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/210chapter205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/211chapter206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 25 YOGA WISDOM: DEVELOP DAILY RITUALS TO ENRICH YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/211chapter206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/212chapter207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 26 YOGA WISDOM: YOGA IS: A GIFT TO YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/212chapter207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/213chapter208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 27 YOGA WISDOM: MAINTAINING HEALTHY PERSONAL BOUNDARIES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/213chapter208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/214chapter209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 28 MUDRA: CONNECT TO YOUR WISDOM")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/214chapter209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/215chapter210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 29 YOGA WISDOM: ALIGN WITH NATURE TO ALIGN WITH YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/215chapter210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/216chapter211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 30 YOGA WISDOM: THE TRUTH WILL SET YOU FREE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/216chapter211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/217chapter212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUL 31 YOGA WISDOM: RELEASE TO RELAX")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/217chapter212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/218chapter213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 1 YOGA WISDOM: DO THE INNER WORK SO YOU CAN FLOURISH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/218chapter213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/219chapter214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 2 YOGA WISDOM: FIND MOTIVATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/219chapter214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/220chapter215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 3 YOGA POSE: BEING STRAIGHTFORWARD IN OUR BODIES AND IN OUR LIVES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/220chapter215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/221chapter216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 4 YOGA WISDOM: FINDING THE SACRED IN NATURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/221chapter216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/222chapter217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 5 YOGA WISDOM: CELEBRATE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/222chapter217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/223chapter218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 6 MANTRA: ACCESS THE PRIMAL POWER OF YOUR FEROCITY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/223chapter218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/224chapter219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 7 YOGA WISDOM: WANDER AND YOU WILL FIND BEAUTY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/224chapter219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/225chapter220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 8 YOGA WISDOM: UNPLUG AND EXPERIENCE THE WORLD MORE FULLY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/225chapter220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/226chapter221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 9 YOGA WISDOM: ALIGN YOURSELF: BODY, MIND, AND HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/226chapter221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/227chapter222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 10 YOGA WISDOM: CULTIVATE INNER PEACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/227chapter222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/228chapter223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 11 MEDITATION: MEDITATE ON TOUCH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/228chapter223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/229chapter224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 12 YOGA WISDOM: WHAT DO YOU REVERE?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/229chapter224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/230chapter225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 13 YOGA POSE: YOUR BODY IS LIKE A WAVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/230chapter225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/231chapter226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 14 YOGA WISDOM: FORGIVENESS BENEFITS YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/231chapter226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/232chapter227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 15 YOGA WISDOM: HELP PEOPLE TO FEEL SEEN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/232chapter227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/233chapter228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 16 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF HANUMAN’S HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/233chapter228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/234chapter229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 17 YOGA WISDOM: RECOGNIZE YOUR CONNECTION TO THE UNIVERSE TO EXPERIENCE ONENESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/234chapter229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/235chapter230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 18 YOGA WISDOM: YOGA IS: SERVING YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/235chapter230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/236chapter231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 19 YOGA WISDOM: AWARENESS GIVES ACCESS TO BEAUTY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/236chapter231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/237chapter232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 20 YOGA POSE: ENGAGE YOUR ENTIRE BODY ON YOUR MAT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/237chapter232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/238chapter233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 21 YOGA WISDOM: SIT WITH ANGER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/238chapter233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/239chapter234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 22 YOGA WISDOM: GIVE THANKS WHEN YOU EAT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/239chapter234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/240chapter235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 23 MEDITATION: MEDITATION IS EASIER THAN YOU THINK")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/240chapter235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/241chapter236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 24 YOGA WISDOM: TREAT YOUR FEET WITH LOVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/241chapter236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/242chapter237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 25 A TALE FROM YOGA MYTHOLOGY: A MYTH OF KRISHNA AND THE MILKMAIDS IN THE FOREST")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/242chapter237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/243chapter238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 26 BREATHING EXERCISE: BREATHE INTO YOUR BONES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/243chapter238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/244chapter239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 27 YOGA WISDOM: LET YOUR DAILY YOGA PRACTICE BE A REFUGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/244chapter239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/245chapter240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 28 YOGA WISDOM: ARE YOUR THOUGHTS ELEVATING YOU OR DRAGGING YOU DOWN?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/245chapter240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/246chapter241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 29 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF HANUMAN MISTAKING THE SUN FOR A MANGO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/246chapter241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/247chapter242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 30 YOGA WISDOM: FOCUS ON ONE TASK AT A TIME TO ACHIEVE BALANCE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/247chapter242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/248chapter243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUG 31 YOGA WISDOM: APPRECIATE WHAT YOU HAVE TO EXPERIENCE CONTENTMENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/248chapter243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/249chapter244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 1 YOGA WISDOM: FIND QUIETUDE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/249chapter244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/250chapter245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 2 MEDITATION: MEDITATE ON YOUR GOALS AND DESIRES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/250chapter245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/251chapter246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 3 YOGA POSE: BE READY FOR TRANSITIONS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/251chapter246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/252chapter247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 4 YOGA WISDOM: MAKE YOUR HOME A SANCTUARY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/252chapter247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/253chapter248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 5 YOGA WISDOM: BELIEVE IN YOURSELF TO OVERCOME SELF-DOUBT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/253chapter248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/254chapter249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 6 MANTRA: I AM THAT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/254chapter249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/255chapter250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 7 YOGA WISDOM: COMMUNITY MATTERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/255chapter250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/256chapter251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 8 YOGA WISDOM: CHALLENGING CONVERSATIONS CAN TRANSFORM RELATIONSHIPS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/256chapter251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("256")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/257chapter252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 9 BREATHING EXERCISE: BREATHE TO BE STEADY WHEN YOUR WORLD IS CHANGING")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/257chapter252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("257")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/258chapter253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 10 MEDITATION: MEDITATE TO UNCLUTTER YOUR MIND")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/258chapter253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/259chapter254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 11 YOGA WISDOM: DEVOTION CAN SHAPE YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/259chapter254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/260chapter255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 12 YOGA POSE: BE FOCUSED AND UNDETERRED IN LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/260chapter255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/261chapter256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 13 YOGA WISDOM: UNCOVER YOUR CREATIVE SELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/261chapter256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/262chapter257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 14 YOGA WISDOM: SET AN INTENTION FOR YOUR YOGA PRACTICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/262chapter257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("262")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/263chapter258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 15 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF GANESHA LOSING HIS HEAD TO GAIN HIS GREATNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/263chapter258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("263")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/264chapter259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 16 YOGA WISDOM: LOVE YOUR BODY TO LOVE YOUR MIND")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/264chapter259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("264")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/265chapter260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 17 YOGA WISDOM: YOUR WORDS CREATE YOUR WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/265chapter260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("265")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/266chapter261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 18 YOGA WISDOM: YOGA IS: YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/266chapter261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/267chapter262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 19 YOGA POSE: YOU HAVE THE POWER TO OPEN YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/267chapter262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/268chapter263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 20 YOGA WISDOM: MANAGING SADNESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/268chapter263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/269chapter264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 21 YOGA WISDOM: END YOUR DAY WITH GRATITUDE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/269chapter264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/270chapter265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 22 MEDITATION: MAKE YOUR DAY INTO MOVING MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/270chapter265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/271chapter266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 23 YOGA WISDOM: YOUR BELLY IS A SOURCE OF INTUITION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/271chapter266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/272chapter267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF BRAHMA AND SARASWATI CREATING THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/272chapter267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("272")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/273chapter268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 25 YOGA WISDOM: DEALING WITH FEELING OVERWHELMED")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/273chapter268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/274chapter269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 26 YOGA WISDOM: RELEASE REGRET TO FREE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/274chapter269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("274")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/275chapter270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 27 MEDITATION: MEDITATE ON THE SPACE BETWEEN THE BREATHS TO FIND PEACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/275chapter270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/276chapter271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 28 YOGA WISDOM: WEAVE YOUR PRACTICE THROUGHOUT YOUR DAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/276chapter271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("276")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/277chapter272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 29 MUDRA: SET AN INTENTION FOR YOUR DAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/277chapter272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/278chapter273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP 30 YOGA WISDOM: ACCEPTING WHAT IS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/278chapter273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/279chapter274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 1 YOGA WISDOM: WHO DO YOU WANT TO BE IN THE WORLD?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/279chapter274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/280chapter275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 2 YOGA WISDOM: LIVE WITH HOPE, NOT WITH EXPECTATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/280chapter275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/281chapter276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 3 YOGA POSE: YOU POSSESS ELEGANCE AND POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/281chapter276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/282chapter277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 4 YOGA WISDOM: SEE YOUR BODY AS A GIFT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/282chapter277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("282")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/283chapter278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 5 YOGA WISDOM: YOUR FLAWS ARE YOUR BEAUTY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/283chapter278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("283")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/284chapter279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 6 MANTRA: I BOW TO THE DIVINITY IN MYSELF AND IN ALL THINGS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/284chapter279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/285chapter280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 7 YOGA WISDOM: CONNECT WITHIN TO CONNECT WITH THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/285chapter280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/286chapter281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 8 YOGA WISDOM: BUILD A HEALTHY RELATIONSHIP WITH YOUR THOUGHTS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/286chapter281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/287chapter282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 9 MEDITATION: MANTRA MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/287chapter282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/288chapter283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 10 YOGA WISDOM: YOUR LOVE IS LIMITLESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/288chapter283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("288")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/289chapter284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 11 YOGA POSE: SINUOUS STRENGTH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/289chapter284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/290chapter285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 12 YOGA WISDOM: OFFERING COMFORT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/290chapter285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("290")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/291chapter286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 13 YOGA WISDOM: HONOR YOUR DREAMS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/291chapter286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/292chapter287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 14 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF BABY KRISHNA, MUD PIES, AND THE UNIVERSE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/292chapter287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/293chapter288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 15 YOGA WISDOM: ABUNDANCE OFFERS CHOICE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/293chapter288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("293")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/294chapter289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 16 YOGA WISDOM: PRACTICE MINDFULNESS IN YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/294chapter289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("294")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/295chapter290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 17 YOGA WISDOM: YOGA IS: ARTISTRY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/295chapter290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("295")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/296chapter291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 18 YOGA POSE: LIKE NATURE, YOU EBB AND FLOW")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/296chapter291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/297chapter292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 19 YOGA WISDOM: ACCESS JOY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/297chapter292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("297")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/298chapter293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 20 YOGA WISDOM: THE IMPORTANCE OF RITUAL")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/298chapter293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("298")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/299chapter294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 21 YOGA WISDOM: BE CONSISTENT TO BE TRUE TO YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/299chapter294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("299")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/300chapter295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 22 MEDITATION: MEDITATE ON LOVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/300chapter295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("300")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/301chapter296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 23 YOGA WISDOM: YOUR BODY IS BEAUTIFUL")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/301chapter296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("301")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/302chapter297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF LAKSHMI AND THE GARLAND OF FLOWERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/302chapter297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("302")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/303chapter298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 25 BREATHING EXERCISE: BREATHE AND EMBRACE YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/303chapter298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/304chapter299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 26 YOGA WISDOM: YOGA OFFERS AN OPPORTUNITY TO EXPERIENCE YOURSELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/304chapter299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("304")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/305chapter300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 27 YOGA WISDOM: ON WAKING UP")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/305chapter300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/306chapter301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 28 YOGA WISDOM: THE PELVIS HOLDS CREATIVE POWER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/306chapter301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("306")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/307chapter302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 29 YOGA WISDOM: BE THE CHANGE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/307chapter302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("307")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/308chapter303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 30 MUDRA: EXPAND YOUR AWARENESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/308chapter303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("308")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/309chapter304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCT 31 YOGA WISDOM: LET IT GO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/309chapter304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/310chapter305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 1 YOGA WISDOM: YOGA IS: INQUIRY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/310chapter305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("310")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/311chapter306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 2 YOGA WISDOM: BALANCE YOUR HEAD AND YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/311chapter306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/312chapter307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 3 YOGA POSE: USE YOUR STRENGTH BUT STAY GROUNDED")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/312chapter307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("312")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/313chapter308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 4 YOGA WISDOM: DISCOVER A UNIVERSE IN EVERY SMALL OBJECT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/313chapter308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/314chapter309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 5 YOGA WISDOM: EMBRACE YOUR MULTIFACETED SELF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/314chapter309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/315chapter310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 6 MANTRA: MAY I ALWAYS DO THE RIGHT THING")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/315chapter310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/316chapter311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 7 YOGA WISDOM: YOU ARE NEVER ALONE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/316chapter311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("316")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/317chapter312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 8 YOGA WISDOM: SET GOALS BUT STAY FLEXIBLE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/317chapter312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("317")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/318chapter313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 9 YOGA WISDOM: CULTIVATE PEACE IN YOUR DAILY LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/318chapter313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/319chapter314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 10 MEDITATION: LOVING KINDNESS MEDITATION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/319chapter314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/320chapter315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 11 YOGA WISDOM: WHAT DO YOU VALUE? GIVE IT LIFE IN THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/320chapter315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/321chapter316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 12 YOGA POSE: BALANCE YOUR BODY TO FIND EASE IN YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/321chapter316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/322chapter317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 13 YOGA WISDOM: EMPATHY HELPS US UNDERSTAND OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/322chapter317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("322")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/323chapter318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 14 YOGA WISDOM: HONOR YOUR EXPERIENCES")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/323chapter318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/324chapter319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 15 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF PARVATI AND SHIVA’S DICE GAME")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/324chapter319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/325chapter320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 16 YOGA WISDOM: ON YOGA AND INTUITION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/325chapter320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/326chapter321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 17 YOGA WISDOM: THANK PEOPLE IN YOUR LIFE TODAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/326chapter321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("326")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/327chapter322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 18 YOGA WISDOM: YOGA IS: GRACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/327chapter322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("327")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/328chapter323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 19 YOGA POSE: LOOK WITHIN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/328chapter323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/329chapter324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 20 YOGA WISDOM: CALMING ANXIETY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/329chapter324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("329")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/330chapter325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 21 YOGA WISDOM: GETTING OUT OF OUR OWN WAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/330chapter325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("330")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/331chapter326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 22 MEDITATION: MEDITATE IN A CROWD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/331chapter326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/332chapter327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 23 YOGA WISDOM: YOUR RIB CAGE IS THE GUARDIAN OF YOUR LUNGS AND HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/332chapter327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/333chapter328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 24 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF HANUMAN’S LEAP ACROSS THE SEA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/333chapter328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/334chapter329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 25 BREATHING EXERCISE: EACH EXHALE IS AN OPPORTUNITY TO RELEASE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/334chapter329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/335chapter330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 26 YOGA WISDOM: PRACTICE AND FLOURISH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/335chapter330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/336chapter331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 27 YOGA WISDOM: WANTING WHAT YOU DON’T HAVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/336chapter331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/337chapter332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 28 YOGA WISDOM: BECOMING SPACIOUS IN OUR BODIES, HEARTS, AND MINDS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/337chapter332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/338chapter333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 29 MUDRA: CLEAR THE WAY FOR AN ABUNDANT LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/338chapter333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/339chapter334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOV 30 YOGA WISDOM: YOGA EMPOWERS US")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/339chapter334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/340chapter335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 1 YOGA WISDOM: CONNECT YOUR MIND AND YOUR HEART TO FIND WISDOM")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/340chapter335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/341chapter336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 2 YOGA WISDOM: SIMPLIFY YOUR DAY BY PRIORITIZING AND LETTING GO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/341chapter336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/342chapter337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 3 YOGA POSE: THE BEAUTIFUL GEOMETRY OF YOU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/342chapter337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("342")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/343chapter338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 4 YOGA WISDOM: TREAT YOUR BODY LIKE A SACRED SPACE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/343chapter338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/344chapter339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 5 MANTRA: LET IT BE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/344chapter339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/345chapter340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 6 YOGA WISDOM: YOU ARE YOUR OWN GURU")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/345chapter340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/346chapter341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 7 MEDITATION: MEDITATE ON THE INNER BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/346chapter341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("346")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/347chapter342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 8 YOGA WISDOM: OFFER LOVE TO GENERATE LOVE IN THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/347chapter342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/348chapter343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 9 YOGA WISDOM: EMBRACE YOUR GREATNESS TO SEE THE GREATNESS IN OTHERS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/348chapter343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/349chapter344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 10 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF GANESHA AND CHANDRA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/349chapter344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("349")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/350chapter345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 11 YOGA WISDOM: BALANCE DREAMS AND REALITY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/350chapter345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/351chapter346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 12 YOGA WISDOM: FIND THE EXPERIENCE OF PEACE BY TURNING WITHIN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/351chapter346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/352chapter347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 13 YOGA WISDOM: YOGA IS: DEVOTION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/352chapter347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/353chapter348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 14 YOGA POSE: MAY YOUR OUTER FORM HONOR YOUR INNER BEAUTY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/353chapter348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("353")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/354chapter349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 15 YOGA WISDOM: RELEASE JEALOUSY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/354chapter349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("354")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/355chapter350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 16 YOGA WISDOM: CULTIVATE GRATITUDE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/355chapter350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/356chapter351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 17 BREATHING EXERCISE: FOCUS ON YOUR EXHALE AS A WAY OF LETTING GO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/356chapter351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("356")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/357chapter352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 18 YOGA WISDOM: LISTEN WITHOUT JUDGING TO UNDERSTAND THE WORLD")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/357chapter352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/358chapter353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 19 A TALE FROM YOGA MYTHOLOGY: THE MYTH OF KALI AND RAKTABIJA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/358chapter353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/359chapter354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 20 BREATHING EXERCISE: THE BREATH INVITES EXPANSIVENESS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/359chapter354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/360chapter355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 21 YOGA WISDOM: THE EBB AND FLOW OF YOUR YOGA PRACTICE OVER TIME")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/360chapter355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("360")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/361chapter356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 22 YOGA POSE: EMBRACE THE RISE AND FALL OF LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/361chapter356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/362chapter357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 23 YOGA WISDOM: OWN YOUR PAST TO SHAPE YOUR FUTURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/362chapter357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("362")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/363chapter358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 24 YOGA WISDOM: FIND EASE IN YOUR HEART")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/363chapter358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("363")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/364chapter359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 25 MEDITATION: MEDITATE ANYWHERE AND EVERYWHERE FOR PEACE OF MIND")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/364chapter359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/365chapter360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 26 YOGA WISDOM: FIND STILLNESS IN MOVEMENT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/365chapter360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/366chapter361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 27 YOGA WISDOM: HONOR YOUR ANCESTORS TO HONOR YOUR LIFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/366chapter361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/367chapter362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 28 YOGA WISDOM: MOVE FROM THE FULLNESS OF THE BACK OF YOUR BODY TO SHAPE YOUR FUTURE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/367chapter362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/368chapter363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 29 YOGA WISDOM: HIBERNATE IN ORDER TO CREATE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/368chapter363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("368")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/369chapter364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 30 MUDRA: REVITALIZE YOUR BODY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/369chapter364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/370chapter365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEC 31 YOGA WISDOM: CHANGE YOUR LIFE NOW")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/370chapter365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("370")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/371acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/371acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("372")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/372author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/372author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("373")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0